import {useSelector} from 'react-redux';

export const ROLES = {
  ADMIN: 'ADMIN',
  PROVIDER_ADMIN: 'PROVIDER_ADMIN',
  PROVIDER_USER: 'PROVIDER_USER',
};

export const useAuth = () => {
  const userInfo = useSelector((state) => state.login.userInfo);
  const userRole = userInfo.role.name;

  const isAdmin = ROLES.ADMIN === userRole;
  const isProviderAdmin = ROLES.PROVIDER_ADMIN === userRole;
  const isProviderUser = ROLES.PROVIDER_USER === userRole;

  return {
    isAdmin,
    isProviderAdmin,
    isProviderUser,
  };
};
